import useSocketService, { EmitStores } from "@/hooks/useSocketService";
import type { EventMilestonesState } from "@/types";

export async function saveMilestoneClaim(params: {
	eventMilestones: EventMilestonesState;
}): Promise<boolean> {
	const socketService = useSocketService();

	try {
		await socketService.emitSaveRequest({
			stores: [EmitStores.RESOURCES, EmitStores.BUILDINGS_STORAGE],
			eventMilestones: params.eventMilestones,
		});
		return true;
	} catch (error: unknown) {
		console.error("[saveMilestoneClaim]", error);
		return false;
	}
}
